<template>
  <div class="button-link-base" :class="{noBorder: noBorder}">
    <span class="button-link" :class="{disable: btnDisable}" @click="onBtnClick"><span class="button-face">{{ buttonFace }}</span></span>
  </div>
</template>

<script>
export default {
  name: "SecButtonLink",
  props: {
    noBorder: {
      type: Boolean,
      default() {
        return false
      }
    },
    buttonFace: {
      type: String,
      default() {
        return ''
      }
    },
    checkThrough:{
      type: Boolean,
      default() {
        return false
      }
    },
    linkUrl: {
      type: String,
      default() {
        return ''
      }
    },
    isOutsideLink: {
      type: Boolean,
      default() {
        return false
      }
    },
    btnDisable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onBtnClick(){
      if(this.isOutsideLink){
        window.open( this.linkUrl, "_blank" ) ;
      }else{
        if(!this.checkThrough){
          this.$emit('link-click', this.linkUrl)
        } else {
          location.href = this.linkUrl
        }
      }
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.button-link-base {
  border-top: 1px solid #E6E9ED;
  width: 100%;
  padding: 30px 0;
  text-align: center;
  .button-link {
    min-width: 270px;
    display: inline-block;
    font-weight: bold;
    font-size: 14px;
    color: white;
    padding: 16px 32px;
    border-radius: 32px;
    cursor: pointer;
    position:relative;
    z-index:1;
    background: $col_def_gradient;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
    user-select: none;
    &::before {
      position:absolute;
      top:0;
      left:0;
      z-index:-1;
      box-sizing:border-box;
      border-radius:2em;
      padding:2px;
      width:100%;
      height:100%;
      background:#fff;
      background-clip:content-box;
      content:"";
    }
    .button-face {
      color: $col_temp_key1;
      background: $col_def_gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    &.disable {
      pointer-events: none;
      background: #DCDFE2;
      .button-face {
        color: #DCDFE2;
        background: none;
        -webkit-text-fill-color: initial;
        -webkit-background-clip: border-box;
      }
    }
  }
  &.noBorder {
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/SecButtonLink.vue